var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPaperclip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.22357 2.22644C9.52646 0.923544 11.6387 0.923544 12.9416 2.22644C14.2445 3.52933 14.2445 5.64154 12.9416 6.94443L8.12023 11.7658C7.27667 12.6093 5.90846 12.6093 5.0649 11.7658C4.22134 10.9222 4.22134 9.554 5.0649 8.71044L8.72224 5.0531C9.01513 4.76021 9.49 4.76021 9.7829 5.0531C10.0758 5.346 10.0758 5.82087 9.7829 6.11376L6.12556 9.7711C5.86779 10.0289 5.86779 10.4473 6.12556 10.7051C6.38334 10.9629 6.8018 10.9629 7.05957 10.7051L11.8809 5.88377C12.598 5.16666 12.598 4.0042 11.8809 3.2871C11.1638 2.56999 10.0013 2.56999 9.28423 3.2871L4.4629 8.10843C3.28646 9.28487 3.28646 11.1913 4.4629 12.3678C5.63934 13.5442 7.5458 13.5442 8.72224 12.3678L11.6482 9.44177C11.9411 9.14888 12.416 9.14888 12.7089 9.44177C13.0018 9.73466 13.0018 10.2095 12.7089 10.5024L9.7829 13.4284C8.02067 15.1907 5.16446 15.1907 3.40224 13.4284C1.64001 11.6662 1.64001 8.81 3.40224 7.04777L8.22357 2.22644Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaperclip);
export default __webpack_public_path__ + "static/media/icon-paperclip.34818d6a2a08edf99693223adf119cd1.svg";
export { ForwardRef as ReactComponent };